import ApiResponse from "../models/ApiResponse";
import LaboratoryResponse from "../models/LaboratoryResponse";
import PagedResponse from "../models/PagedResponse";
import LaboratoryNameRequest from "../models/test-request/LaboratoryNameRequest";
import LaboratoryRelationRequest from "../models/test-request/LaboratoryRelationRequest";
import LaboratoryUserResponse from "../models/test-request/LaboratoryUserResponse";
import ManagedLaboratoryResponse from "../models/test-request/ManagedLaboratoryResponse";
import Api from "./Api";
import LaboratoryNotificationConfigurationResponse from "../models/test-request/LaboratoryNotificationConfigurationResponse";
import LaboratoryNotificationConfigurationRequest from "../models/test-request/LaboratoryNotificationConfigurationRequest";

class LaboratoriesApi {
  constructor(private api: Api) {}

  public fetchLaboratories(): ApiResponse<LaboratoryResponse[]> {
    return this.api.get("/test-request/v2/laboratories");
  }

  /**
   * Get the laboratories managed by the current user.
   * The list contains laboratory managers, assigned and subscribed users.
   */
  public fetchManagedLaboratories(): ApiResponse<ManagedLaboratoryResponse[]> {
    return this.api.get("/test-request/v2/laboratories/managed");
  }

  /**
   *
   * Updates laboratory the name.
   * @param laboratoryId The id of the laboratory
   * @param data The data to be updated
   */
  public editLaboratoryName(laboratoryId: number, data: LaboratoryNameRequest): ApiResponse<ManagedLaboratoryResponse> {
    return this.api.put(`/test-request/v2/laboratories/${laboratoryId}/name`, data);
  }

  /**
   * Update the assigned and subscribed users to the laboratory.
   * @param laboratoryId The id of the laboratory
   * @param data An object containing a list of assignedUserIds and subscribedUserIds
   */
  public editLaboratoryRelations(
    laboratoryId: number,
    data: LaboratoryRelationRequest,
  ): ApiResponse<ManagedLaboratoryResponse> {
    return this.api.put(`/test-request/v2/laboratories/${laboratoryId}/relations`, data);
  }

  /**
   * Get the assignable users to the laboratory.
   * @param laboratoryId The id of the laboratory
   * @param data The search term to filter the assignable users
   * @returns
   */

  public getAssignableUsers(
    laboratoryId: number,
    searchTerm: string,
  ): ApiResponse<PagedResponse<LaboratoryUserResponse>> {
    const params = new URLSearchParams([["searchTerm", searchTerm]]);
    return this.api.get(`/test-request/v2/laboratories/${laboratoryId}/assignable-users/`, { params });
  }

  public editNotificationConfiguration(
    laboratoryId: number,
    data: LaboratoryNotificationConfigurationRequest,
  ): ApiResponse<LaboratoryNotificationConfigurationResponse> {
    return this.api.put(`/test-request/v2/laboratories/${laboratoryId}/notificationconfiguration`, data);
  }
}

export default LaboratoriesApi;
